import styled from "styled-components";
import { Typography } from "./Typography";

/**
 * [共通パーツ]ラベル
 */

type Props = {
  text: string;
  emphasis?: "required" | "optional" | "note"; // 「必須」か「任意」かの文字を表示する
  note?: string;
  margin?: string;
};

const Container = styled.div<{ $margin?: string }>`
  display: flex;
  ${({ $margin }) => $margin && `margin: ${$margin}`}
`;

const RequiredWrapper = styled.div`
  color: ${({ theme }) => theme.colors.caution};
`;

const OptionalWrapper = styled.div`
  color: ${({ theme }) => theme.colors.good};
`;

const NoteWrapper = styled.div`
  color: ${({ theme }) => theme.colors.good};
  margin-left: 5px;
`;

export function Label({ text, emphasis, note, margin }: Props) {
  return (
    <Container $margin={margin}>
      <Typography size={1} bold>
        {text}
      </Typography>
      {emphasis === "required" && (
        <RequiredWrapper>
          <Typography size={1}>（必須）</Typography>
        </RequiredWrapper>
      )}
      {emphasis === "optional" && (
        <OptionalWrapper>
          <Typography size={1}>（任意）</Typography>
        </OptionalWrapper>
      )}
      {emphasis === "note" && (
        <NoteWrapper>
          <Typography size={1}>{note}</Typography>
        </NoteWrapper>
      )}
    </Container>
  );
}
